/* ============================================================================
   Luxury reveal animations — Bayt El Muhajaba
   Adds gentle fade + slide-up reveals as elements enter the viewport, plus a
   clip-path "unveil" on imagery (styled in luxury.css).

   Safety model: the hidden pre-animation state lives in CSS behind the
   `.luxe-anim-ready` class, which is added here. If this script never runs,
   bails early, or throws, that class is absent/removed and every element stays
   fully visible. Reduced-motion users are opted out entirely.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  // Respect user preferences & capability. If unmet, do nothing → content
  // remains visible because the CSS hidden state requires `.luxe-anim-ready`.
  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced || !('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.product-grid__card',
    '.collection-card',
    '.luxe-trust__item',
    '[data-luxe-reveal]'
  ];

  try {
    root.classList.add('luxe-anim-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    var prepare = function (el, indexInGroup) {
      if (el.classList.contains('luxe-reveal')) return;
      el.classList.add('luxe-reveal');
      el.style.setProperty('--luxe-i', Math.min(indexInGroup, 7));

      // Elements already in or above the first viewport on load reveal
      // instantly (no animation, no flash). Everything else animates on scroll.
      var rect = el.getBoundingClientRect();
      var inViewNow = rect.top < window.innerHeight && rect.bottom > 0;
      if (inViewNow) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    };

    var scan = function (scope) {
      var groups = new Map();
      SELECTORS.forEach(function (sel) {
        (scope || document).querySelectorAll(sel).forEach(function (el) {
          var parent = el.parentElement || document.body;
          var count = groups.get(parent) || 0;
          prepare(el, count);
          groups.set(parent, count + 1);
        });
      });
    };

    var start = function () {
      scan(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    // Theme editor: re-scan freshly rendered sections.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        scan(e.target || document);
      });
    }
  } catch (err) {
    // Any failure → undo the hidden state so nothing is ever stuck invisible.
    root.classList.remove('luxe-anim-ready');
  }
})();
